<template>
  <div class="container">
    <div class="courier-delivery-how">
      <h2>Как это работает</h2>

      <div class="courier-delivery-how-list">
        <div
          v-for="(stage, index) in stages"
          :key="stage.title"
          class="courier-delivery-how-card"
        >
          <img
            :src="stage.icon.url"
            alt=""
            class="courier-delivery-how-icon"
          >

          <div class="courier-delivery-how-content">
            <div class="courier-delivery-how-number">
              {{ index + 1 }}.
            </div>
            <div>
              <div class="courier-delivery-how-title">
                {{ stage.title }}
              </div>
              <div class="courier-delivery-how-description">
                {{ stage.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="courier-delivery-available">
      <h2>Что можно отправить</h2>

      <ul class="courier-delivery-available-list">
        <li
          v-for="item in sendItems"
          :key="item"
        >
          {{ item }}
        </li>
      </ul>

      <div class="courier-delivery-limits">
        <div class="courier-delivery-limits-title">
          <span>Ограничения</span> по весу и габаритам
        </div>
        <div class="courier-delivery-limits-list">
          <div
            v-for="item in limitItems"
            :key="item.text"
            class="courier-delivery-limits-item"
          >
            <img
              :src="item.icon"
              alt=""
              class="courier-delivery-limits-icon"
            >
            <div class="courier-delivery-limits-item-text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="courier-delivery-packaging">
    <div class="courier-delivery-packaging-content container">
      <div class="courier-delivery-packaging-img">
        <img
          src="@/assets/images/box.webp"
          alt=""
        >
      </div>

      <div class="courier-delivery-packaging-info">
        <h2>
          Безопасность отправлений — надёжная упаковка
        </h2>

        <div class="courier-delivery-packaging-list">
          <div
            v-for="item in packagingItems"
            :key="item.title"
            class="courier-delivery-packaging-item"
          >
            <img
              :src="item.icon"
              alt=""
              class="courier-delivery-packaging-item-icon"
            >
            <div>
              <div class="courier-delivery-packaging-item-title">
                {{ item.title }}
              </div>
              <div class="courier-delivery-packaging-item-description">
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="container">
    <div class="courier-delivery-price">
      <div class="courier-delivery-price-header">
        <h2>
          Сколько стоит курьерская доставка
        </h2>
        <a
          href="#courier-delivery-calculator"
          class="courier-delivery-price-link"
        >
          Рассчитать мою доставку
        </a>
      </div>

      <div class="courier-delivery-price-description">
        Стоимость зависит от расстояния, веса, габаритов и способа передачи и получения отправления.
      </div>

      <div class="courier-delivery-price-list">
        <a
          v-for="(item, index) in priceItems"
          :key="`${item.direction}-${item.price}-${index}`"
          href="#courier-delivery-calculator"
          class="courier-delivery-price-card"
          @click="selectPriceDirection(item)"
        >
          <div class="courier-delivery-price-card-icon">
            <img
              src="@/assets/icons/pin.svg"
              alt=""
              class="courier-delivery-price-card-icon-img"
            >
          </div>
          <div class="courier-delivery-price-card-content">
            <div class="courier-delivery-price-card-info">
              <div class="courier-delivery-price-card-route">
                {{ item.direction }}
              </div>
              <div class="courier-delivery-price-card-price">
                {{ item.price }}
              </div>
            </div>
            <div class="courier-delivery-price-card-term">
              {{ item.term }}
            </div>
          </div>
          <span class="courier-delivery-price-card-arrow">›</span>
        </a>
      </div>
    </div>

    <div
      class="courier-delivery-business"
      :class="{'courier-delivery-business--light-text': lightTextBusinessBrands.includes(terminalBrandName)}"
    >
      <div class="courier-delivery-business-header">
        <img
          src="@/assets/icons/box_1.svg"
          alt=""
          class="courier-delivery-business-icon"
        >
        <div>
          <div class="courier-delivery-business-title">
            Курьерская доставка для бизнеса и интернет-магазинов
          </div>
          <div class="courier-delivery-business-subtitle">
            Решения для компаний, которые отправляют регулярно
          </div>
        </div>
      </div>

      <div class="courier-delivery-business-grid">
        <div
          v-for="item in businessItems"
          :key="item.title"
          class="courier-delivery-business-item"
        >
          <div class="courier-delivery-business-item-title">
            {{ item.title }}
          </div>
          <div class="courier-delivery-business-item-description">
            {{ item.description }}
          </div>
        </div>

        <div class="courier-delivery-business-action">
          <router-link
            :to="{ name: 'contacts' }"
            class="courier-delivery-business-button"
          >
            Стать клиентом
          </router-link>
        </div>
      </div>
    </div>

    <div
      id="courier-delivery-documents"
      class="courier-delivery-documents"
    >
      <h2>Документы</h2>

      <div class="courier-delivery-documents-description">
        Всё важное об условиях курьерской доставки.
      </div>

      <div class="courier-delivery-documents-list">
        <a
          v-for="item in documentItems"
          :key="item.title"
          :href="item.href"
          target="_blank"
          class="courier-delivery-documents-card"
        >
          <img
            src="@/assets/icons/docs.svg"
            alt=""
            class="courier-delivery-documents-card-icon"
          >
          <div class="courier-delivery-documents-card-content">
            <div class="courier-delivery-documents-card-title">
              {{ item.title }}
            </div>
            <div class="courier-delivery-documents-card-description">
              {{ item.description }}
            </div>
            <span class="courier-delivery-documents-card-link">
              Скачать PDF
            </span>
          </div>
        </a>
      </div>
    </div>

    <faq-list
      class="courier-delivery-content-faq"
      title="Вопросы и ответы"
      :items="faqItems"
    />
  </div>
</template>

<script>
import {computed} from 'vue'
import FaqList from '@/components/FaqList.vue'

function createStages(terminalBrandName) {
  return [
    {
      icon: {
        url: require('@/assets/icons/docs.svg')
      },
      title: 'Оформите отправление',
      description: 'Укажите города, параметры отправления и данные получателя'
    },
    {
      icon: {
        url: require('@/assets/icons/box.svg')
      },
      title: 'Передайте отправление',
      description: `Вызовите курьера по адресу или самостоятельно привезите отправление на терминал ${terminalBrandName}`
    },
    {
      icon: {
        url: require('@/assets/icons/car.svg')
      },
      title: 'Мы перевезём отправление',
      description: 'Доставим его в город получателя. Статус отправления можно отслеживать онлайн'
    },
    {
      icon: {
        url: require('@/assets/icons/check.svg')
      },
      title: 'Получите удобным способом',
      description: `Курьер доставит отправление по адресу, получатель заберёт его на терминале ${terminalBrandName} или в выбранном ПВЗ Яндекса`
    }
  ]
}

const sendItems = [
  'Документы и корреспонденцию',
  'Посылки, личные вещи и подарки',
  'Электронику и бытовую технику',
  'Одежду, обувь и аксессуары',
  'Запчасти и комплектующие',
  'Заказы интернет-магазинов'
]

const limitItems = [
  {
    icon: require('@/assets/icons/crane.svg'),
    text: 'Общий вес - до 200 кг'
  },
  {
    icon: require('@/assets/icons/weight.svg'),
    text: 'Вес 1 места - до 30 кг'
  },
  {
    icon: require('@/assets/icons/box_2.svg'),
    text: 'Максимальная сторона 1 места - до 1,2 м'
  }
]

function createPackagingItems(terminalBrandName) {
  return [
    {
      icon: require('@/assets/icons/box_3.svg'),
      title: 'Надёжно упакуйте отправление',
      description: 'Упаковка должна соответствовать весу, размерам и особенностям содержимого и обеспечивать его сохранность при перевозке.'
    },
    {
      icon: require('@/assets/icons/shield.svg'),
      title: 'Закажите дополнительную упаковку',
      description: `Если отправлению нужна дополнительная защита, упаковку можно заказать у ${terminalBrandName}.`
    },
    {
      icon: require('@/assets/icons/check.svg'),
      title: 'Для некоторых отправлений нужна защитная упаковка',
      description: 'Электроника, изделия со стеклом и керамикой, отдельные автозапчасти и некоторые другие категории перевозятся только с защитной транспортной упаковкой.'
    }
  ]
}

const priceItems = [
  {
    direction: 'Москва - Санкт-Петербург',
    from: 'e90f1820-0128-11e5-80c7-00155d903d03',
    to: 'e90f19de-0128-11e5-80c7-00155d903d03',
    price: 'от 580 ₽',
    term: 'Срок: 1–2 дня'
  },
  {
    direction: 'Нижний Новгород - Москва',
    from: '1d016bfc-0127-11e5-80c7-00155d903d03',
    to: 'e90f1820-0128-11e5-80c7-00155d903d03',
    price: 'от 520 ₽',
    term: 'Срок: 1–2 дня'
  },
  {
    direction: 'Москва - Краснодар',
    from: 'e90f1820-0128-11e5-80c7-00155d903d03',
    to: '46475680-0125-11e5-80c7-00155d903d03',
    price: 'от 530 ₽',
    term: 'Срок: 1–2 дня'
  },
  {
    direction: 'Казань - Самара',
    from: 'f2a303ff-0124-11e5-80c7-00155d903d03',
    to: 'fa0a4b98-0127-11e5-80c7-00155d903d03',
    price: 'от 480 ₽',
    term: 'Срок: 1–2 дня'
  }
]

const businessItems = [
  {
    title: 'Личный кабинет',
    description: 'Заказы, документы и оплата в одном месте'
  },
  {
    title: 'API-интеграция',
    description: 'Передавайте данные о заказах автоматически'
  },
  {
    title: 'Наложенный платёж',
    description: 'Получатель может оплатить товар при получении'
  },
  {
    title: 'Возвраты',
    description: 'Организуем обратную доставку товара'
  },
  {
    title: 'Много отправлений',
    description: 'Оформляйте сразу несколько заказов'
  }
]

function createFaqItems(terminalBrandName) {
  return [
    {
      question: 'Что такое курьерская доставка?',
      answer: `Курьерская доставка ${terminalBrandName} — это доставка небольших отправлений между городами. Вы можете передать отправление курьеру или самостоятельно привезти его на терминал ${terminalBrandName}, а получатель — получить по указанному адресу, на терминале ${terminalBrandName} или в ПВЗ Яндекса.`
    },
    {
      question: 'Как передать отправление?',
      answer: `Выберите удобный вариант при оформлении заказа. Курьер может забрать отправление по указанному адресу, либо вы можете самостоятельно привезти его на терминал ${terminalBrandName}.`
    },
    {
      question: `Можно ли самостоятельно привезти отправление на терминал ${terminalBrandName}?`,
      answer: `Да. После оформления заказа вы можете самостоятельно доставить отправление на выбранный терминал ${terminalBrandName} и передать его сотруднику компании. Учитывайте время приёма отправлений на терминале — от него может зависеть срок доставки.`
    },
    {
      question: 'Как можно получить отправление?',
      answer: `Получатель может выбрать доступный для направления способ получения: доставку курьером по указанному адресу, получение на терминале ${terminalBrandName} или в ПВЗ Яндекса. Доступные варианты отображаются при расчёте и оформлении доставки.`
    },
    {
      question: `Можно ли забрать отправление на терминале ${terminalBrandName}?`,
      answer: `Да. При оформлении заказа выберите получение на терминале ${terminalBrandName}. После прибытия отправления получатель сможет самостоятельно забрать его на выбранном терминале.`
    },
    {
      question: 'Можно ли получить отправление в ПВЗ Яндекса?',
      answer: 'Да, если для выбранного направления доступна доставка в ПВЗ Яндекса. При оформлении выберите подходящий пункт выдачи, а после поступления отправления получатель сможет забрать его там.'
    },
    {
      question: 'Какие отправления можно отправлять?',
      answer: 'Курьерская доставка подходит для документов, посылок, личных вещей, одежды и обуви, электроники, комплектующих, запчастей и заказов интернет-магазинов. Для отдельных категорий действуют ограничения по содержимому, упаковке и страхованию.'
    },
    {
      question: 'Какие отправления не принимаются к доставке?',
      answer: 'К доставке не принимаются запрещённые и опасные отправления, в том числе скоропортящиеся продукты, живые растения и животные, оружие, взрывчатые и радиоактивные вещества, наркотические и психотропные вещества, денежные средства и некоторые другие категории. С полным перечнем можно ознакомиться в разделе «Документы».'
    },
    {
      question: 'Нужно ли упаковывать отправление?',
      answer: `Да. Отправление необходимо передать в упаковке, соответствующей его весу, габаритам и особенностям содержимого. Если подходящей упаковки нет или отправлению требуется дополнительная защита, можно заказать упаковку у ${terminalBrandName}.`
    },
    {
      question: 'Как отследить отправление?',
      answer: 'Статус и текущее местонахождение отправления можно посмотреть онлайн по номеру заказа. Также отправитель и получатель получают уведомления об основных этапах доставки.'
    }
  ]
}

export default {
  name: 'CourierDeliveryContent',
  components: {
    FaqList
  },
  props: {
    documentItems: {
      type: Array,
      required: true
    },
    terminalBrandName: {
      type: String,
      required: true
    }
  },
  emits: ['select-price-direction'],
  setup(props, {emit}) {
    const faqItems = computed(() => createFaqItems(props.terminalBrandName))
    const packagingItems = computed(() => createPackagingItems(props.terminalBrandName))
    const stages = computed(() => createStages(props.terminalBrandName))
    const lightTextBusinessBrands = ['ЮГТранс ТЭК', '«Транспортных технологий»']

    function selectPriceDirection(item) {
      emit('select-price-direction', item)
    }

    return {
      businessItems,
      faqItems,
      limitItems,
      lightTextBusinessBrands,
      packagingItems,
      priceItems,
      selectPriceDirection,
      sendItems,
      stages
    }
  }
}
</script>

<style lang="scss" scoped>
$pub-md: 1239px;
$pub-sm: 768px;
$pub-xs: 480px;

.container {
  max-width: 1240px;
  width: 97%;
  margin-left: auto;
  margin-right: auto;
}

.courier-delivery {
  &-how {
    margin-top: 100px;
    text-align: left;

    h2 {
      font-size: 30px;
      text-align: left;
    }

    &-list {
      margin-top: 30px;
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 24px;
    }

    &-card {
      position: relative;
      padding: 44px 30px 30px;
      box-sizing: border-box;
      border: 1px solid #D9DCDE;
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
      text-align: left;

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: -18px;
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 9px solid #7a7f84;
        transform: translateY(-50%);
        z-index: 2;
      }

      &:last-child::after {
        display: none;
      }
    }

    &-icon {
      display: block;
      width: 56px;
      height: 56px;
      margin: 0 auto 30px;
      object-fit: contain;
      filter: var(--primary-filter);
    }

    &-content {
      display: grid;
      grid-template-columns: auto minmax(0, 1fr);
      gap: 10px;
      align-items: start;
    }

    &-number {
      font-size: 24px;
      line-height: 1.25;
      font-weight: 700;
      color: var(--font-1);
      margin-top: -4px;
    }

    &-title {
      font-size: 18px;
      line-height: 1.25;
      font-weight: 700;
      color: var(--font-1);
    }

    &-description {
      margin-top: 8px;
      font-size: 16px;
      line-height: 1.22;
      font-weight: 400;
      color: var(--font-2);
    }
  }

  &-available {
    margin-top: 100px;

    h2 {
      margin-top: 0;
      font-size: 30px;
      text-align: left;
      text-transform: none;
    }

    &-list {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 20px 80px;
      padding-left: 0;
      font-size: 18px;
      color: var(--font-1);
      list-style: none;

      li {
        position: relative;
        margin-bottom: 0 !important;
        padding-left: 26px;
        text-align: left;

        &::before {
          content: '';
          position: absolute;
          top: 10px;
          left: 0;
          width: 6px;
          height: 6px;
          background: var(--primary-color);
        }
      }
    }
  }

  &-limits {
    font-family: Roboto, sans-serif;
    margin-top: 30px;
    padding: 40px;
    border-radius: 16px;
    background: #F8F8F8;

    &-title {
      text-transform: uppercase;
      color: var(--font-1);
      font-weight: 600;
      text-align: left;
      font-size: 20px;

      span {
        color: inherit;
      }
    }

    &-list {
      margin-top: 20px;
      display: grid;
      grid-template-columns: repeat(3, max-content);
      gap: 70px;
      font-weight: 500;
    }

    &-item {
      display: flex;
      align-items: center;
      gap: 16px;

      img {
        flex: 0 0 auto;
      }

      &-text {
        font-size: 16px;
        color: var(--font-1);
      }
    }

    &-icon {
      display: block;
      width: 24px;
      height: 24px;
      object-fit: contain;
      filter: var(--primary-filter);

      &[src=''] {
        visibility: hidden;
      }
    }
  }

  &-packaging {
    margin-top: 60px;
    padding: 60px 0;
    background: var(--bg-2);

    &-info {
      text-align: left;

      h2 {
        margin: 0;
        text-align: left;
        text-transform: uppercase;
      }
    }

    &-content {
      display: grid;
      grid-template-columns: minmax(260px, 420px) minmax(0, 1fr);
      align-items: center;
      gap: 60px;
    }

    &-img {
      display: flex;
      justify-content: center;

      img {
        max-width: 320px;
        width: 100%;
        height: auto;
        display: block;
      }
    }

    &-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 35px;
    }

    &-item {
      display: flex;
      align-items: flex-start;
      gap: 10px;

      &-icon {
        filter: var(--primary-filter);
      }

      &-title {
        font-size: 18px;
        font-weight: 600;
      }

      &-description {
        margin-top: 6px;
        color: var(--font-2);
      }
    }

  }

  &-price {
    margin-top: 100px;

    &-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 20px;

      h2 {
        margin: 0;
        margin-right: auto;
        font-size: 30px;
        text-align: left;
      }
    }

    &-link {
      margin-top: 8px;
      color: var(--font-3);
      white-space: nowrap;
      font-size: 16px;
      text-decoration: underline;
    }

    &-description {
      margin-top: 30px;
      font-size: 16px;
      color: var(--font-1);
      text-align: left;
    }

    &-list {
      margin-top: 30px;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 20px;
    }

    &-card {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 6px;
      padding: 24px;
      border: 1px solid var(--line);
      border-radius: 12px;
      color: var(--font-1);
      text-decoration: none;
      transition: box-shadow 100ms ease-in;

      &-icon {
        height: 94%;

        &-img {
          display: block;
          width: 24px;
          height: 24px;
          object-fit: contain;
          filter: var(--primary-filter);
        }
      }

      &:hover {
        box-shadow: var(--box-shadow);
      }

      &-content {
        flex: 1 1 auto;
        min-width: 0;
      }

      &-info {
        display: flex;
        align-items: baseline;
        gap: 10px;
        text-align: left;
      }

      &-route {
        min-width: 0;
        font-size: 16px;
      }

      &-price {
        flex: 0 0 auto;
        font-weight: 700;
        font-size: 18px;
        white-space: nowrap;
      }

      &-term {
        margin-top: 6px;
        font-size: 14px;
        color: var(--font-3);
        text-align: left;
      }

      &-arrow {
        flex: 0 0 auto;
        color: var(--font-3);
        font-size: 30px;
      }
    }
  }

  &-business {
    margin-top: 100px;
    padding: 40px 60px;
    border-radius: 16px;
    background: var(--primary-color);
    text-align: left;

    &--light-text {
      color: white;

      .courier-delivery-business-icon {
        filter: brightness(0) invert(1);
      }

      .courier-delivery-business-item-title::before {
        background: white;
      }
    }

    &-header {
      display: flex;
      align-items: flex-start;
      gap: 20px;
    }

    &-icon {
      filter: brightness(0) saturate(100%) invert(27%) sepia(1%) saturate(1208%) hue-rotate(314deg) brightness(97%) contrast(84%);
    }

    &-title {
      font-size: 32px;
      line-height: normal;
      font-weight: 700;
    }

    &-subtitle {
      margin-top: 12px;
      font-size: 18px;
      font-weight: 500;
    }

    &-grid {
      margin-top: 30px;
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 10px;
    }

    &-item {
      padding: 20px;
      border-radius: 16px;
      background: rgba(255, 255, 255, .16);

      &-title {
        position: relative;
        padding-left: 20px;
        font-size: 18px;
        font-weight: 700;

        &::before {
          content: '';
          position: absolute;
          top: 9px;
          left: 0;
          width: 6px;
          height: 6px;
          background: var(--font-1);
        }
      }

      &-description {
        margin-top: 6px;
        padding-left: 20px;
        font-size: 16px;
      }
    }

    &-action {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 116px;
    }

    &-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 240px;
      height: 48px;
      border: 1px solid #fff;
      border-radius: 4px;
      background: #fff;
      color: var(--font-1);
      font-size: 18px;
      font-weight: 400;
      text-decoration: none;
      transition: background-color 0.15s ease;

      &:hover {
        background: var(--primary-color);
      }
    }
  }

  &-documents {
    margin-top: 100px;
    text-align: left;

    h2 {
      font-size: 30px;
    }

    &-description {
      font-size: 16px;
      color: var(--font-1);
    }

    &-list {
      margin-top: 30px;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 20px;
    }

    &-card {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      padding: 30px;
      border-radius: 16px;
      background: var(--bg-2);
      color: var(--font-1);
      text-decoration: none;

      &-icon {
        display: block;
        flex: 0 0 auto;
        width: 32px;
        height: 32px;
        object-fit: contain;
        filter: var(--primary-filter);
      }

      &-content {
        min-width: 0;
      }

      &-title {
        font-weight: 700;
      }

      &-description {
        margin-top: 6px;
        font-size: 16px;
        color: var(--font-2);
      }

      &-link {
        display: inline-block;
        margin-top: 10px;
        font-size: 16px;
        color: var(--font-3);
        text-decoration: underline;
      }
    }
  }

  &-content-faq {
    margin-bottom: 100px;
  }

  @media screen and (max-width: $pub-md - 1) {
    &-how {
      &-list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }

      &-card:nth-child(even) {
        &::after {
          display: none;
        }
      }
    }

    &-limits {
      &-list {
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
        text-align: left;
      }
    }

    &-packaging {
      padding: 40px 0;

      &-content {
        grid-template-columns: 252px 1fr;
        gap: 28px;
      }
    }
  }

  @media screen and (max-width: $pub-sm) {
    &-how {
      &-card {
        padding: 30px;
      }
    }

    &-available {
      &-list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px 40px;
      }
    }

    &-limits {
      &-list {
        grid-template-columns: repeat(3, auto);
        gap: 50px;
      }

      &-item {
        gap: 8px;
      }
    }

    &-price {
      &-card {
        &-info {
          flex-direction: column;
          gap: 4px;
        }
      }
    }

    &-business {
      padding: 40px;

      &-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }
  }

  @media screen and (max-width: $pub-xs) {
    &-how {
      &-list {
        grid-template-columns: 1fr;
        gap: 16px;
      }

      &-card {
        min-height: auto;
        padding: 32px 24px;

        &::after {
          display: none;
        }
      }

      &-icon {
        margin-bottom: 28px;
      }

      &-number,
      &-title {
        font-size: 20px;
      }

      &-description {
        font-size: 16px;
      }
    }

    &-available {
      &-list {
        grid-template-columns: 1fr;
        margin-left: 15px;
        gap: 14px;
      }
    }

    &-limits {
      padding: 30px;

      &-list {
        grid-template-columns: 1fr;
        gap: 20px;
      }

      &-item {
        gap: 8px;
      }
    }

    &-packaging {
      padding: 20px 0;

      &-content {
        grid-template-columns: 1fr;
        gap: 10px;
      }

    }

    &-price {
      &-header {
        flex-direction: column;
        gap: 10px;
      }

      &-link {
        margin-top: 0;
      }

      &-description {
        margin-top: 20px;
      }

      &-list {
        grid-template-columns: 1fr;
      }
    }

    &-business {
      padding: 30px 20px;

      &-title {
        font-size: 22px;
      }

      &-grid {
        grid-template-columns: 1fr;
      }

      &-action {
        margin-top: 20px;
        min-height: 0;

        &-button {
          max-height: unset;
        }
      }
    }

    &-documents {
      &-list {
        grid-template-columns: 1fr;
        gap: 10px;
      }

      &-card {
        padding: 30px 20px;
      }
    }
  }
}
</style>
